import { EmailConfirmation } from '@features/auth/registration';
import { useTranslation } from 'react-i18next';

const LoginEmailConfirmation = () => {
	const { t } = useTranslation();

	return (
		<EmailConfirmation
			checkEmailText={t('checkEmail')}
			emailSuccessText={t('loginEmailSuccess')}
			checkEmailVerifyText={t('loginCheckEmailVerify')}
			emailLoadText={t('emailLoad')}
			emailIssueText={t('emailIssue')}
			resendEmailText={t('resendEmail')}
			goBackLoginText={t('goBackLogin')}
		/>
	);
};

export default LoginEmailConfirmation;
